import { RootScopeEvents } from '../../../services/root-scope-types';
import AbstractTrack from '../abstract.track';
export default class FlipCameraClickTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'user flip camera';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.USER_ACTIONS.FLIP_CAMERA, () => {
            this.trackButtonEventSegment({
                button_action: 'flip camera',
                button_text: null,
                button_type: 'button',
            });
        });
    }
}
